import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import { UserProvider } from "./context/UserContext";

import Auth0ProviderWithNavigate from './features/auth/Auth0ProviderWithNavigate';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Auth0ProviderWithNavigate>
        <AuthProvider>
          <UserProvider>
            <App />
          </UserProvider>
          </AuthProvider>
      </Auth0ProviderWithNavigate>
    </BrowserRouter>
  </React.StrictMode>
);

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     {/* <Auth0Provider
//       domain={domain}
//       clientId={clientId}
//       authorizationParams={{
//     redirect_uri: window.location.origin,
//     audience: "https://someet-api",
//     scope: "openid profile email"
//       }}
//       // useRefreshTokens={true}
//       // cacheLocation="localstorage"
//     > */}
//           <Auth0ProviderWithNavigate>

//     <AuthProvider>
//       <App />
//     </AuthProvider>
//     </Auth0ProviderWithNavigate>
//     {/* </Auth0Provider> */}
//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
